import * as Sentry from "@sentry/react-router"

/**
 * Set the Sentry user context for error tracking
 * This helps identify which user experienced an error
 */
export const setSentryUser = (
  id: string | null,
  email?: string,
  displayName?: string
) => {
  if (id) {
    Sentry.setUser({
      id,
      email,
      username: displayName,
    })
  } else {
    // Clear user context on logout
    Sentry.setUser(null)
  }
}
